// webSubMenuList?projectId=1

import { createSlice } from "@reduxjs/toolkit";

import { createApiThunk, updateState } from "../utilityFunction"

// Initial State
const initialState = {
    fetchWebSubMenu: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
    saveSubMenu: {
        loading: false,
        success: false,
        error: false,
        message: null,
        data: null,
    },
};

// Async Thunk for Fetching Setting Data
export const fetchWebSubMenuData = createApiThunk("WebSubMenu", "fetch")
export const saveWebSubMenuData = createApiThunk("WebSubMenu", "save")

// Slice
const webSubMenuSlice = createSlice({
    name: "webSubmenu",
    initialState,

    reducers: {
        resetSubmenuState: (state, action) => {
            const type = action.payload; // Assuming the type is passed in the action's payload

            if (type === "fetch") {
                state.fetchWebSubMenu = {
                    ...state.fetchWebSubMenu, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            } else if (type === "save") {
                state.saveSubMenu = {
                    ...state.saveSubMenu, // Preserve existing data
                    loading: false,
                    success: false,
                    error: false,
                    message: null,
                };
            }
        },
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchWebSubMenuData.pending, (state) => updateState(state, "pending", "fetchWebSubMenu"))
            .addCase(fetchWebSubMenuData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "fetchWebSubMenu", action.payload.data))
            .addCase(fetchWebSubMenuData.rejected, (state, action) =>
                updateState(state, "rejected", "fetchWebSubMenu", action.payload))
            // Save data
            .addCase(saveWebSubMenuData.pending, (state) => updateState(state, "pending", "saveSubMenu"))
            .addCase(saveWebSubMenuData.fulfilled, (state, action) =>
                updateState(state, "fulfilled", "saveSubMenu", action.payload.data))
            .addCase(saveWebSubMenuData.rejected, (state, action) =>
                updateState(state, "rejected", "saveSubMenu", action.payload));
    },
});

export const { resetSubmenuState } = webSubMenuSlice.actions;
export default webSubMenuSlice.reducer;
